<!-- 机构-教师考勤统计 -->
<template>
  <div>
    <div class="index" v-show="!detail.show">
      <div class="title">
        <div class="span1">
          <span>{{$route.name}}</span>
        </div>
        <p style="color:#606266;font-size:14px;">截止日期: {{dayjs().format('YYYY-MM-DD')}}</p>
      </div>

      <!-- <header>
        <div class="header-item">
          <div class="header-item-title">
            <span class="circle"></span>
            <span>教师考勤率前五名</span>
          </div>
          <div id="echarts-box1"></div>
        </div>

        <div class="header-item">
          <div class="header-item-title">
            <span class="circle"></span>
            <span>教师考勤率后五名</span>
          </div>
          <div id="echarts-box2"></div>
        </div>
      </header> -->
       <el-form :inline="true" :model="queryParams" label-width="70px">
          <el-form-item label="">
            <el-select
              v-model="queryParams.semester"
              placeholder="选择学年学期"
              class="label"
            >
              <el-option v-for="item in semesterList"  :key="item.id+'semester'" :label="item.label" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker 
				   	v-model="queryParams.time"
				   	type="daterange"
				   	style="width: 240px;"
				   	range-separator="-"
				   	start-placeholder="开始日期"
				   	end-placeholder="结束日期"
            :clearable="false"
				   	:picker-options="pickerOptions">
				   	</el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <el-select
              v-model="queryParams.teacher"
              clearable
              placeholder="选择授课教师"
              class="label"
            >
              <el-option v-for="item in teacherList"  :key="item.user_id+'teacherList'" :label="item.name" :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" style="margin-left: 20px">
            <el-button type="primary" size="small" @click="searchFun()"
              >搜索</el-button
            >
          </el-form-item>
        </el-form>
      <div>
        <div class="table">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="teacherName" label="授课教师" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="courseNum" label="授课课程数" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="classHours" label="课时总数" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="needAttendanceNum" label="应出勤次数" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="attendanceNum" label="实际出勤次数" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="attendanceRate" label="出勤率" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column header-align="center" align="center" label="操作" width="200" fixed="right">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="toDetail(scope.row)"
                  >查看详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination
              background
              :current-page="pageNum"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              :total="totalPage"
              layout="total,prev, pager, next,jumper,sizes"
              @size-change="sizeChangeHandle"
              @current-change="currentChangeHandle"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <Detail
      :info="detail.info"
      :semester="queryParams.semester"
      :time="time"
      v-show="detail.show"
      @to-index="toIndex"
    ></Detail>
  </div>
</template>
<script>
import api from "@/api/wisdomSchool/index.js";
import dayjs from "dayjs";
import * as echarts from "echarts";
import { schoolTeacherList, } from "@/api/user/userCenter";
export default {
  components: {
    Detail: () => import("./detail.vue"),
  },
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      totalPage: 0,
      queryParams: {
        semester: "2021-2022_2",
        teacher: "",
        name: "",
        time:[
          this.getNowMonthFirst(),
          new Date(),
        ],
      },
      sourceList: [],
      semesterList: [
        {id:'2021-2022_1',label:'2021-2022 上学期'},
        {id:'2021-2022_2',label:'2021-2022 下学期'},
        {id:'2022-2023_1',label:'2022-2023 上学期'},
        {id:'2022-2023_2',label:'2022-2023 下学期'},
        {id:'2023-2024_1',label:'2023-2024 上学期'},
        {id:'2023-2024_2',label:'2023-2024 下学期'},
      ],
      teacherList: [],
      tableData: [],
      detail: {
        info: {},
        show: false,
      },
      pickerOptions: {
				// disabledDate(time) {
				// 	return time.getTime() > Date.now();
				// },
			},
      school_info: JSON.parse(sessionStorage.getItem("classList")),
      time: {
        start:'',
        end:'',
      },
    };
  },
  watch: {

  },
  created() {
      // 教师考勤统计
      // http://{{gateway-addr}}/app-elective/remote/api/statistics/org/teacher/attendance?platformCode=999999&extOrgId=b97227d46e0811ec980e020315f3f1bd&startDate=2022-06-06&endDate=2022-06-20&teacherName&page=1&limit=10&schoolYearSemester=2021-2022_2
      
      // 开班列表
      // http://{{gateway-addr}}/app-elective/remote/api/statistics/org/courseApplyList?extOrgId=b97227d46e0811ec980e020315f3f1bd&platformCode=999999&page=1&limit=10&searchDate=2022-03-21
      // 开班列表导出
      // http://{{gateway-addr}}/app-elective/remote/api/statistics/org/exportCourseApplyList?extOrgId=b97227d46e0811ec980e020315f3f1bd&platformCode=999999&courseName
  },
  methods: {
    dayjs,
    async initData(){
      try{
        // 获取机构教师列表
        let teacherRes=await schoolTeacherList({
          top_org_id:sessionStorage.orgId,
          page:1,
          page_size:500,
          user_type: "1,5",
          need_role: "1",
        });
        if(teacherRes.code==='000000'){
          this.teacherList=teacherRes.result.member_list || [];
        }else{
          this.$message.error('获取老师信息失败');
        }
      }catch(err){
        console.log(err)
      }
    },
    async getDataList() {
      let start = "",
        end = "";
      if(this.queryParams.time){
        start = dayjs(this.queryParams.time[0]).format('YYYY-MM-DD');
        end = dayjs(this.queryParams.time[1]).format('YYYY-MM-DD');
      }
      let params = {
        extOrgId: sessionStorage.getItem("orgId"),
        platformCode: sessionStorage.getItem("platformCode"),
        schoolYearSemester: this.queryParams.semester,
        teacherName: this.queryParams.teacher,
        startDate: start,
        endDate: end,
        page: this.pageNum,
        limit: this.pageSize,
      };
      let res = await api.getOrgTeacherAttendance(params);
      console.log('机构-教师考勤统计列表',res)
      if (res.code === "0") {
        this.tableData = res.data?.list || [];
        this.totalPage = res.data?.total || 0;
        this.time.start = start;
        this.time.end = end;
      }
    },
    searchFun() {
      this.pageNum = 1;
      this.getDataList();
    },
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.getDataList();
    },
    currentChangeHandle(val) {
      this.pageNum = val;
      this.getDataList();
    },
    toDetail(item) {
      this.detail.info = item;
      this.detail.show = true;
    },
    toIndex() {
      this.detail.show = false;
    },

    /**
     * 获取本月第一天
     */
    getNowMonthFirst(){
      const date = new Date()
      date.setDate(1)
      return date
    },

    /**
    * 获取本月最后一天
    */
    getNowMonthLast(){
      const date = new Date()
      const enddate = new Date(date.getFullYear(), date.getMonth() + 1, 0)
      return enddate
    },

    init(){
      let vm = this;
      this.$nextTick(() => {
        // 圆环图
        let chartDom1 = document.getElementById('echarts-box1');
        let myChart = echarts.init(chartDom1);
        let option = {
          tooltip: {
            trigger: 'item',
            backgroundColor: 'rgba(0, 0, 0, .6)', //通过设置rgba调节背景颜色与透明度
            borderWidth: '0',
            textStyle: {
              color: 'white',
              fontSize: '12',
            },
            formatter: function (params, ticket, callback) {
              return "<span style='font-size: 26px;line-height: 30px;'>" + params.value + '</span>' + '<br />' + "<span style='font-size:14px;line-height: 18px;'>" + params.name + '</span>';
            },
          },
          grid: {
            height: 200,
            top: 30,
            left: 42,
          },
          xAxis: {
            type: 'category',
            data: ['庄萍雅', '杨萍蓓', '严姣婷', '昌琦嘉', '奚秋叶'],
            // splitLine: {show: false},//去除网格分割线
            axisLine: {
              //坐标线
              lineStyle: {
                type: 'solid',
                color: '#DDDDDD', //轴线的颜色
                width: '1', //坐标线的宽度
              },
            },
            axisLabel: {
              textStyle: {
                color: '#999999', //坐标值的具体的颜色
              },
            },
          },
          yAxis: {
            type: 'value',
          },
          series: [
            {
              data: [100, 100, 100, 97.87, 95.23],
              type: 'bar',
              showBackground: true,
              backgroundStyle: {
                // 背景颜色
                color: 'none', //'#E8F6FF'
              },
              itemStyle: {
                // 柱子颜色
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    // { offset: 0, color: '#009DFD' },
                    { offset: 1, color: '#5BB0FF' },
                  ]),
                  // barBorderRadius: 16, // 柱子圆角, 单位为px
                },
              },
              barWidth: 20, //设置柱子宽度，单位为px
            },
          ],
        };
        myChart.setOption(option);

        // 柱状图
        let chartDom2 = document.getElementById('echarts-box2');
        let myChart2 = echarts.init(chartDom2);
        let option2 = {
          tooltip: {
            trigger: 'item',
            backgroundColor: 'rgba(0, 0, 0, .6)', //通过设置rgba调节背景颜色与透明度
            borderWidth: '0',
            textStyle: {
              color: 'white',
              fontSize: '12',
            },
            formatter: function (params, ticket, callback) {
              return "<span style='font-size: 26px;line-height: 30px;'>" + params.value + '</span>' + '<br />' + "<span style='font-size:14px;line-height: 18px;'>" + params.name + '</span>';
            },
          },
          grid: {
            height: 200,
            top: 30,
            left: 42,
          },
          xAxis: {
            type: 'category',
            data: ['戚晶仁', '詹希聪', '寿歌姣', '习华伊', '闫媛娣'],
            // splitLine: {show: false},//去除网格分割线
            axisLine: {
              //坐标线
              lineStyle: {
                type: 'solid',
                color: '#DDDDDD', //轴线的颜色
                width: '1', //坐标线的宽度
              },
            },
            axisLabel: {
              textStyle: {
                color: '#999999', //坐标值的具体的颜色
              },
            },
          },
          yAxis: {
            type: 'value',
          },
          series: [
            {
              data: [81.81, 84.44, 85.71, 86.95, 91.42],
              type: 'bar',
              showBackground: true,
              backgroundStyle: {
                // 背景颜色
                color: 'none', //'#E8F6FF'
              },
              itemStyle: {
                // 柱子颜色
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    // { offset: 0, color: '#51D6A6' },
                    { offset: 1, color: '#51D6A6' },
                  ]),
                  // barBorderRadius: 16, // 柱子圆角, 单位为px
                },
              },
              barWidth: 20, //设置柱子宽度，单位为px
            },
          ],
        };
        myChart2.setOption(option2);

        // 柱状图
        let chartDom3 = document.getElementById('echarts-box3');
        let myChart3 = echarts.init(chartDom3);
        let option3 = {
          tooltip: {
            trigger: 'item',
            backgroundColor: 'rgba(0, 0, 0, .6)', //通过设置rgba调节背景颜色与透明度
            borderWidth: '0',
            textStyle: {
              color: 'white',
              fontSize: '12',
            },
            formatter: function (params, ticket, callback) {
              return "<span style='font-size: 26px;line-height: 30px;'>" + params.value + '</span>' + '<br />' + "<span style='font-size:14px;line-height: 18px;'>" + params.name + '</span>';
            },
          },
          grid: {
            height: 200,
            top: 30,
            left: 42,
          },
          xAxis: {
            type: 'category',
            data: ['课程1', '课程1', '课程1', '课程1', '课程1'],
            axisLine: {
              //坐标线
              lineStyle: {
                type: 'solid',
                color: '#DDDDDD', //轴线的颜色
                width: '1', //坐标线的宽度
              },
            },
            axisLabel: {
              textStyle: {
                color: '#999999', //坐标值的具体的颜色
              },
            },
          },
          yAxis: {
            type: 'value',
          },
          series: [
            {
              data: [110, 210, 256, 146, 388],
              type: 'bar',
              showBackground: true,
              backgroundStyle: {
                // 背景颜色
                color: 'none', //'#E8F6FF'
              },
              itemStyle: {
                // 柱子颜色
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 1, color: '#51D6A6' },
                  ]),
                },
              },
              barWidth: 20, //设置柱子宽度，单位为px
            },
          ],
        };
        myChart3.setOption(option3);
      });
    },
  },
  mounted() {
    this.initData();
    this.getDataList();
    // this.init();
  },
};
</script>
<style lang="less" scoped>
.index {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .title {
    height: 60px;
    line-height: 48px;
    border-bottom: 1px solid #eaeaea;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    .span1 {
      font-family: "PingFang SC Bold";
      font-weight: bold;
      font-size: 20px;
      text-align: left;
      color: #000;
      margin-right: 30px;
    }
  }

  ::v-deep .el-form .el-input__inner {
    // width: 150px;
    height: 32px;
    border-radius: 3px;
    background: #fff;
    border: 1px solid #ddd;
  }

  ::v-deep .el-table__header tr th {
    background: #f7f7f7;
    box-shadow: 0px 1px 0px #eaeaea;
  }

  ::v-deep .el-date-editor .el-range-separator {
    line-height: 22px;
  }

  .pagination {
    text-align: center;
    margin-top: 30px;
  }
}
header{
  width: 100%;
  height: 350px;
  display: flex;
  .header-item{
    width: 48%;
    .header-item-title{
      font-size: 18px;
      color: #333;
      display: flex;
      align-items: center;
      .circle{
        width: 8px;
        height: 8px;
        display: inline-block;
        background: #4991e1;
        border-radius: 50%;
        margin-right: 10px;
      }
    }
    .header-item-text{
      font-size: 14px;
      color: #666;
      padding-left: 20px;
      margin-top: 5px;
    }
  }
  #echarts-box1{
    width:380px;
    height:280px;
  }
  #echarts-box2,#echarts-box3{
    width:500px;
    height:280px;
  }
  #echarts-box3{
    margin-top: 25px;
  }
}
</style>
